import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  // 企业列表
  getvendors: option => request3('v1/vendor/getvendors', option, true),
  // 上传小程序代码 vendorId=&templateId=
  commitwxapp: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/commitwxapp' + urls, {}, true)
  },
  // 查询商家小程序页面 vendorId=
  wxagetpage: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/wxagetpage' + urls, {}, true)
  },
  // 查询商家小程序目录 vendorId=
  wxagetcategory: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/wxagetcategory' + urls, {}, true)
  },
  // 小程序提交审核 json {vendorId, item_list}
  submitaudit: option => {
    return request3('v1/wxapp3party/submitaudit', option, true, false)
  },
  // 撤销审核
  undocodeaudit: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/undocodeaudit' + urls, {}, true)
  },
  // 发布
  releasewxapp: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/releasewxapp' + urls, {}, true)
  },
  // 初始化企业数据
  initvendor: option => {
    const urls = urlStringify(option)
    return request3('v1/vendor/initvendor' + urls, {}, true)
  },
  // 初始化企业数据
  changeenv: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/changeenv' + urls, {}, true)
  },
  // 获取体验二维码
  getqrcode: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/getqrcode' + urls, {}, true, false, true)
  },
  // 绑定体验者
  bindtester: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/bindtester' + urls, {}, true)
  },
  gettemplatelist: option =>
    request3('v1/wxapp3party/gettemplatelist', option, true), // 查询小程序模板列表
  gettemplatedraftlist: option =>
    request3('v1/wxapp3party/gettemplatedraftlist', option, true), // 查询草稿列表
  // 增加到模板库
  addwxapptemplate: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/addwxapptemplate' + urls, {}, true)
  },
  // 删除模板
  deletewxapptemplate: option => {
    const urls = urlStringify(option)
    return request3('v1/wxapp3party/deletewxapptemplate' + urls, {}, true)
  }
}
